export const PIXEL_SCALE = 3
export const UI_ICON_SIZE = 8
export const UI_CELL_SIZE = 20
export const PIXEL_FONT_FAMILY = '"Silkscreen", monospace'

export function getWorldPixelScale(zoom = 2, defaultZoom = 2, semanticScale = 1) {
  const zoomScale = Math.max(1, Math.round(PIXEL_SCALE * (zoom / defaultZoom)))
  const integerScale = Math.max(1, Math.round(semanticScale))
  return zoomScale * integerScale
}

export function drawPixelSpriteToCanvas(canvas, sprite, palette = null, pixelScale = 1) {
  if (!canvas || !sprite?.pixels) return

  const ctx = canvas.getContext('2d')
  const scale = Math.max(1, Math.floor(pixelScale))
  const offsetX = Math.floor((canvas.width - sprite.width * scale) / 2)
  const offsetY = Math.floor((canvas.height - sprite.height * scale) / 2)

  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.imageSmoothingEnabled = false

  for (let y = 0; y < sprite.height; y++) {
    for (let x = 0; x < sprite.width; x++) {
      const sourceColor = sprite.pixels[y * sprite.width + x]
      if (!sourceColor || sourceColor === 'transparent') continue

      const color = palette?.[sourceColor] || sourceColor
      ctx.fillStyle = color
      ctx.fillRect(offsetX + x * scale, offsetY + y * scale, scale, scale)
    }
  }
}
